import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button,
  Form,
  TextArea
} from 'semantic-ui-react'

const DPOHistoryReviewTPUX = React.forwardRef((props: any, ref: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div>
        <div
          style={{ display: "flex", marginBottom: "10px" }}>

          <div
            style={{ padding:15 }}>
            {props.languageUX === "en" ? "Date" : "Date"}
          </div>
          <div
            style={{padding: "5px"}}>
            { props.tpStartDate}
          </div>
          <div
            style={{ padding:15 }}>
            -
          </div>
          <div
            style={{padding: "5px"}}>
            { props.tpEndDate}
          </div>
          <Button
            className={props.patientId === null ? "disabled" : ""}
            color="blue"
            onClick={props.handleGetHistoryTp}
            size="mini"
            style={{ margin: "7px 15px", }}>
            {props.languageUX === "en" ? "Search" : "ค้นหา"}
          </Button>
        </div>
        <div
          style={{ display: "flex", height: "100%", padding: "10px" }}>
          <div>
            {props.cardFilterDentistTpElement}
          </div>
          <div>
            {props.cardFilterClinicTpElement}
          </div>
          <div>
            {props.cardFilterLocationTpElement}
          </div>
          <div>
            {props.cardFilterStatusTpElement}
          </div>
          <div>
            {props.cardFilterTreatmentTpElement}
          </div>
          <div>
            {props.cardFilterTreatmentCodeTpElement}
          </div>
          <Table
            NoDataComponent={() => null}
            columns={props.columnsHistoryTp}
            data={props.historyReviewTpData}
            defaultPageSize=" 5"
            getTrProps={props.handleOnFocusFindingsRowTp}
            pageSize="5"
            showPagination={false}
            sortable={false}
            style={{height:props.tableHeight ?? "655px", width:"100%"}}>
          </Table>
        </div>
        <div
          style={{ display: "none", height: "100%", padding: "10px" }}>

          <div
            style={{ width: "70%" }}>

            <div
              style={{ display: "flex" , margin:"0 0 1em"   }}>

              <div
                style={{ display: "flex" , flex: 2  }}>

                <label
                  style={{fontSize:"16px", fontWeight:"bold" }}>
                  {props.languageUX === "en" ? "Treatment Record" : "Treatment Record"}
                </label>
              </div>
              <div
                style={{ display: "flex" , textAlign: "right" }}>

                <div>
                  {props.iconClose}
                </div>
              </div>
            </div>
            <div
              style={{ width: "100%" }}>

              <Form>
                <TextArea
                  className="disabled"
                  rows={4}
                  value={props.treatmentRecord || ""}>
                </TextArea>
              </Form>
            </div>
          </div>
        </div>
        <div
          style={{ ...(props.hideTreatmentForm && {display: true }), width: "80%"}}>
          {props.treatmentRecord}
        </div>
      </div>
    )
})

DPOHistoryReviewTPUX.displayName = "DPOHistoryReviewTPUX";
export default React.memo(DPOHistoryReviewTPUX)

export const screenPropsDefault = {"diagnosis":"tooth cavity"}

/* Date Time : Tue Aug 20 2024 16:56:37 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 0,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", height: \"100%\", padding: \"10px\" }"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 8,
      "name": "Table",
      "parent": 7,
      "props": {
        "NoDataComponent": {
          "type": "code",
          "value": "() => null"
        },
        "columns": {
          "type": "code",
          "value": "props.columnsHistoryTp"
        },
        "data": {
          "type": "code",
          "value": "props.historyReviewTpData"
        },
        "defaultPageSize": {
          "type": "value",
          "value": " 5"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.handleOnFocusFindingsRowTp"
        },
        "pageSize": {
          "type": "value",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "sortable": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height:props.tableHeight ?? \"655px\", width:\"100%\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", marginBottom: \"10px\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "Date",
          "valueEN": "Date"
        },
        "style": {
          "type": "code",
          "value": "{ padding:15 }"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": " props.tpStartDate"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "-"
        },
        "style": {
          "type": "code",
          "value": "{ padding:15 }"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": " props.tpEndDate"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "className": {
          "type": "code",
          "value": "props.patientId === null ? \"disabled\" : \"\""
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "onClick": {
          "type": "code",
          "value": "props.handleGetHistoryTp"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"7px 15px\", }"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cardFilterDentistTpElement"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cardFilterClinicTpElement"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cardFilterLocationTpElement"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cardFilterStatusTpElement"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"none\", height: \"100%\", padding: \"10px\" }"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ width: \"70%\" }"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" , margin:\"0 0 1em\"   }"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" , flex: 2  }"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" , textAlign: \"right\" }"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "label",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": "Treatment Record",
          "valueEN": "Treatment Record"
        },
        "style": {
          "type": "code",
          "value": "{fontSize:\"16px\", fontWeight:\"bold\" }"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "code",
          "value": "props.iconClose"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Form",
      "parent": 22,
      "props": {
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "TextArea",
      "parent": 27,
      "props": {
        "className": {
          "type": "value",
          "value": "disabled"
        },
        "onChange": {
          "type": "code",
          "value": ""
        },
        "rows": {
          "type": "code",
          "value": "4"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.treatmentRecord || \"\""
        }
      },
      "seq": 28,
      "void": true
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cardFilterTreatmentTpElement"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cardFilterTreatmentCodeTpElement"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.treatmentRecord"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.hideTreatmentForm && {display: true }), width: \"80%\"}"
        }
      },
      "seq": 31,
      "void": false
    }
  ],
  "forwardRef": true,
  "height": 80,
  "isMounted": true,
  "memo": true,
  "name": "DPOHistoryReviewTPUX",
  "project": "cudent",
  "screenPropsDefault": {
    "diagnosis": "tooth cavity"
  },
  "width": 80
}

*********************************************************************************** */
